import Ajax from '../ajax';

const controller = 'report';

export default {
  swapOutPoint: (data) => Ajax('get', `${controller}/swapOutPoint`, data),
  exportSwapOutPoint: (data) => Ajax('get', `${controller}/exportSwapOutPoint`, data),
  swapOutProduct: (data) => Ajax('get', `${controller}/swapOutProductByPointOnly`, data),
  exportSwapOutProduct: (data) => Ajax('get', `${controller}/exportSwapOutProductByPointOnly`, data),
  userPoint: (data) => Ajax('get', `${controller}/userConsumptionSummary`, data),
  exportUserPoint: (data) => Ajax('get', `${controller}/exportUserConsumptionSummary`, data),
  swapOutProductByPointAndCash: (data) => Ajax('get', `${controller}/swapOutProductByPointAndCash`, data),
  exportSwapOutProductByPointAndCash: (data) => Ajax('get', `${controller}/exportSwapOutProductByPointAndCash`, data),
  swapOutDiscountCoupon: (data) => Ajax('get', `${controller}/swapOutDiscountCoupon`, data),
  exportSwapOutDiscountCoupon: (data) => Ajax('get', `${controller}/exportSwapOutDiscountCoupon`, data),
  swapIn: (data) => Ajax('get', `${controller}/swapIn`, data),
  exportSwapIn: (data) => Ajax('get', `${controller}/exportSwapIn`, data),
  storeDailyPaymentSummery: (data) => Ajax('get', `${controller}/storeDailyPaymentSummery`, data),
  storeSummaryFileLink: (id) => Ajax('get', `${controller}/storeSummaryFileLink/${id}`),
  listPayment: (data) => Ajax('get', `${controller}/listPayment`, data),
  exportPayment: (data) => Ajax('get', `${controller}/exportPayment`, data),
  listSuperPointGenerate: (data) => Ajax('get', `${controller}/listPointGenerate`, data),
  exportSuperPointGenerate: (data) => Ajax('get', `${controller}/exportPointGenerate`, data),
};
